import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"
import { Hash, Building2, MapPin, Users, Mail, Navigation, ExternalLink } from "lucide-react"
import type { Commune } from "@/types"

export function CommuneInfoCard({ commune }: { commune: Commune }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Informations</CardTitle>
        <CardDescription>Données administratives et géographiques</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          <InfoItem icon={Hash} label="Code INSEE">
            <span className="font-mono">{commune.insee_code}</span>
          </InfoItem>
          <InfoItem icon={Building2} label="Département">
            {commune.department_name ? `${commune.department_code} - ${commune.department_name}` : "—"}
          </InfoItem>
          <InfoItem icon={MapPin} label="Région">
            {commune.region_name || "—"}
          </InfoItem>
          <InfoItem icon={Users} label="Population">
            {commune.population ? <Badge variant="secondary">{commune.population.toLocaleString("fr-FR")}</Badge> : "—"}
          </InfoItem>
          <InfoItem icon={Mail} label="Codes postaux">
            {commune.postal_codes || "—"}
          </InfoItem>
          <InfoItem icon={Navigation} label="Coordonnées">
            {commune.latitude && commune.longitude ? (
              <a
                href={`https://www.google.com/maps/@${commune.latitude},${commune.longitude},13z`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1 font-mono text-sm text-primary hover:underline"
              >
                {commune.latitude}, {commune.longitude}
                <ExternalLink className="size-3" />
              </a>
            ) : (
              "—"
            )}
          </InfoItem>
        </div>
      </CardContent>
    </Card>
  )
}

function InfoItem({
  icon: Icon,
  label,
  children,
}: {
  icon: React.ComponentType<{ className?: string }>
  label: string
  children: React.ReactNode
}) {
  return (
    <div className="rounded-lg bg-muted/50 px-3 py-2.5">
      <p className="text-muted-foreground flex items-center gap-1.5 text-xs font-medium">
        <Icon className="size-3.5" />
        {label}
      </p>
      <p className="mt-0.5">{children}</p>
    </div>
  )
}
